"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSessionInactivityTimeoutReached = exports.isSessionDurationExceeded = exports.isSessionState = void 0;
const constants_1 = require("./constants");
const isSessionState = (maybeSessionState) => typeof maybeSessionState === 'object' &&
    maybeSessionState !== null &&
    'id' in maybeSessionState &&
    typeof maybeSessionState['id'] === 'string' &&
    maybeSessionState.id.length === constants_1.SESSION_ID_LENGTH &&
    'startTime' in maybeSessionState &&
    typeof maybeSessionState['startTime'] === 'number';
exports.isSessionState = isSessionState;
const isSessionDurationExceeded = (sessionState) => {
    const now = Date.now();
    return sessionState.startTime > now || now > sessionState.startTime + constants_1.SESSION_DURATION_MS;
};
exports.isSessionDurationExceeded = isSessionDurationExceeded;
const isSessionInactivityTimeoutReached = (sessionState) => {
    if (sessionState.expiresAt === undefined) {
        return false;
    }
    const now = Date.now();
    return now > sessionState.expiresAt;
};
exports.isSessionInactivityTimeoutReached = isSessionInactivityTimeoutReached;
//# sourceMappingURL=utils.js.map